/* eslint-disable */
// @ts-nocheck

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react'

import useServerOnlineClients from '../../../../api/useServerOnlineClients'
import AsyncComboBox from '../../../../components/forms/AsyncCombobox'
import InlineRadio from '../../../../components/forms/InlineRadio'
import Input from '../../../../components/forms/Input'
import TextArea from '../../../../components/forms/TextArea'
import Toggle from '../../../../components/forms/Toggle'
import Button from '../../../../components/misc/Button'
import { useAppSelector } from '../../../../store/hooks'
import { RegisterContext } from '../AllRegistersList'
import { EditContextBilling } from '../registerDetailsTabs/RegisterDetailsTab'

export const ClientDataStep = () => {
  const { addClient, isFetching } = useServerOnlineClients()
  const {
    control,
    setValue,
    getValues,
    trigger,
    watch,
    setCurrentStep,
    currentStep,
    clearErrors,
    isFetching: isFetchingUpdate,
  } = useContext(RegisterContext)
  const { defaultValues, editMode } = useContext(EditContextBilling)
  const { business } = useAppSelector((state) => state.init)

  const enableDelivery =
    business?.configurationsKey.find((itm) => itm.key === 'enable_delivery')
      ?.value === 'true'
  const RadioValues = [
    {
      label: 'Existente',
      value: 'existingClient',
    },
    {
      label: 'Nuevo',
      value: 'newClient',
    },
  ]
  const handleNewClient = async (data: any) => {
    setValue!('clientId', data.id)
    setValue!('client', '')
    setCurrentStep!(2)
  }
  const isExistingClient = watch!('isExistingClient')
  const onSubmit = async () => {
    if (
      await trigger!([
        'client.firstName',
        'client.ci',
        'client.firstName',
        'clientId',
        'client.phones[0].number',
        'client.email',
        'client.address.street_1',
        'client.address.street_2',
        'client.address.city',
        'client.address.municipality.id',
        'client.address.province.id',
        'client.address.country.id, client.customerCategory',
      ])
    ) {
      const clientId = watch!('clientId')
      setValue!('clientId', clientId)

      if (isExistingClient === 'newClient') {
        const dataClient = watch!('client')
        await addClient!(dataClient, handleNewClient)
      } else {
        setCurrentStep!(currentStep! + 1)
      }
    }
  }
  useEffect(() => {
    setValue!('isExistingClient', RadioValues[0].value)
    setValue!('clientId', editMode ? defaultValues?.client?.id : undefined)
  }, [])

  return (
    <div className="grid min-h-[25rem] gap-x-16 px-8">
      <div>
        <div className="grid">
          <div>
            <InlineRadio
              control={control}
              data={RadioValues}
              defaultValue={RadioValues[0].value}
              name="isExistingClient"
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            {isExistingClient === 'existingClient' && (
              <>
                <div className="col-span-2">
                  <AsyncComboBox
                    control={control}
                    dataQuery={{
                      url: '/customer',
                      defaultParams: { page: 1 },
                    }}
                    label="Nombre (*)"
                    name="clientId"
                    normalizeData={{
                      id: 'id',
                      name: ['firstName', 'lastName', 'email'],
                      format: 'firstName lastName  email',
                    }}
                    rules={{
                      required: 'Este campo es requerido',
                      onChange: (e) => clearErrors!('clientId'),
                    }}
                    undefinedFormat=" "
                  />
                </div>

                <div className="col-span-2">
                  <TextArea
                    control={control}
                    defaultValue={editMode && defaultValues?.customerNote}
                    label="Notas del cliente"
                    name="customerNotes"
                  />
                </div>
              </>
            )}
            {isExistingClient === 'newClient' && (
              <>
                <div className="col-span-2">
                  <Input
                    control={control}
                    label="Nombre (*)"
                    name="client.firstName"
                    rules={{
                      required: 'Este campo es requerido',
                      onChange: (e) => clearErrors!('client.firstName'),
                    }}
                  />
                </div>
                <div className="grid gap-2">
                  <Input
                    control={control}
                    label="Apellidos"
                    name="client.lastName"
                    type="text"
                  />
                  <Input
                    control={control}
                    label="No. de identificación"
                    maxLength={15}
                    name="client.ci"
                    rules={{
                      maxLength: {
                        value: 15,
                        message: 'Debe introducir un número menor a 15 dígitos',
                      },
                    }}
                    textAsNumber
                  />
                  <Input
                    control={control}
                    label="Teléfono"
                    maxLength={10}
                    name="client.phones[0].number"
                    rules={{
                      maxLength: {
                        value: 10,
                        message: 'Debe introducir un número menor a 10 dígitos',
                      },
                    }}
                    textAsNumber
                    type="number"
                  />
                  <Input
                    control={control}
                    label="Correo electrónico"
                    name="client.email"
                    rules={{
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message:
                          'Por favor, ingrese una dirección de correo electrónico válida',
                      },
                    }}
                  />

                  <Input
                    control={control}
                    label="No. de contrato"
                    name="client.contractNumber"
                    rules={{
                      required: 'Este campo es requerido',
                      onChange: (e) => clearErrors!('client.address.street_1'),
                    }}
                  />
                  <AsyncComboBox
                    control={control}
                    dataQuery={{
                      url: '/customer/categories/customer',
                      defaultParams: { all_data: true },
                    }}
                    label="Tipo de cliente"
                    name="client.customerCategoryId"
                    normalizeData={{ id: 'id', name: 'name' }}
                  />
                </div>

                <div>
                  <div className="grid grid-rows-5 gap-2">
                    <Input
                      control={control}
                      label="Calle principal"
                      name="client.address.street_1"
                      rules={{
                        onChange: (e) =>
                          clearErrors!('client.address.street_1'),
                      }}
                    />

                    <Input
                      control={control}
                      label="Calle secundaria"
                      name="client.address.street_2"
                    />

                    <Input
                      control={control}
                      label="Localidad "
                      name="client.address.city"
                      rules={{
                        onChange: (e) => clearErrors!('client.address.city'),
                      }}
                    />
                    <AsyncComboBox
                      control={control}
                      dataQuery={{
                        url: '/public/countries',
                        defaultParams: { search: 'Cuba' },
                      }}
                      defaultItem={{ id: 54, name: 'Cuba' }}
                      defaultValue={54}
                      label="País "
                      name="client.address.countryId"
                      normalizeData={{ id: 'id', name: 'name' }}
                      rules={{
                        onChange: (e) =>
                          clearErrors!('client.address.countryId'),
                      }}
                    />
                    <AsyncComboBox
                      control={control}
                      dataQuery={{ url: '/public/provinces' }}
                      dependendValue={{
                        countryId:
                          watch!('client.address.countryId') ??
                          getValues!('client.address.countryId'),
                      }}
                      label="Provincia"
                      name="client.address.provinceId"
                      normalizeData={{ id: 'id', name: 'name' }}
                    />
                    <AsyncComboBox
                      control={control}
                      dataQuery={{ url: '/public/municipalities' }}
                      dependendValue={{
                        provinceId:
                          watch!('client.address.provinceId') ??
                          getValues!('client.address.provinceId'),
                      }}
                      disabled={!watch!('client.address.provinceId')}
                      label="Municipio"
                      name="client.address.municipalityId"
                      normalizeData={{ id: 'id', name: 'name' }}
                    />
                  </div>
                </div>

                <div className="col-span-2 row-span-2 grid">
                  <TextArea
                    control={control}
                    label="Notas legales"
                    name="client.legalNotes"
                  />
                </div>

                <div className="col-span-2">
                  <TextArea
                    control={control}
                    label="Notas del cliente"
                    name="customerNotes"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {enableDelivery && (
          <div>
            <Toggle
              control={control}
              defaultValue={editMode ? !defaultValues?.pickUpInStore : false}
              name="shippingType"
              title="Programar entrega"
            />
          </div>
        )}
      </div>

      <div className="row-span-2 flex w-full items-end">
        {!editMode ? (
          <div className="grid w-full grid-cols-2 gap-3 pt-2">
            <Button
              action={() => {
                setCurrentStep!(currentStep! - 1)
                setValue!('client', '')
              }}
              color="white"
              disabled={currentStep === 0 ? true : false}
              full
              name="Atrás"
              outline
              textColor="blue-800"
              type="button"
            />
            <Button
              action={onSubmit}
              color="slate-700"
              disabled={isFetching}
              full
              loading={isFetching}
              name="Continuar"
              type="button"
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
      {editMode && (
        <div className="row-span-2 flex w-full items-end justify-end">
          <div className="grid">
            <Button
              color="slate-700"
              disabled={isFetchingUpdate}
              full
              loading={isFetchingUpdate}
              name={editMode ? 'Actualizar' : `Registrar`}
              type="submit"
            />
          </div>
        </div>
      )}
    </div>
  )
}
